export default "__VITE_ASSET__BsE0hSg1__"